export default "__VITE_ASSET__95f73d97__"